import AxiosService from "@src/services/axiosService";
import { apiLogger } from "@src/services/workers/helpers";
import { useCallback } from "react";
import { HoldingJob } from ".";
import config from "@src/utilities/config";

const axiosService = new AxiosService(`${config.api.wbs}/api/`, apiLogger, "Holding Jobs Modal", true, undefined, true);

// Custom hook for fetching jobs
export const useFetchHoldingJobs = () => {
    // Memoize the fetchJobs function using useCallback
    const fetchJobs = useCallback(async (): Promise<HoldingJob[]> => {
        try {
            return await axiosService.get<HoldingJob[]>('sp_Reports_SalesAgentScreen4_Get');
        } catch (error) {
            console.error('Error fetching jobs:', error);
            throw new Error('Failed to fetch holding jobs');
        }
    }, []);

    return { fetchJobs };
};
